import {iFrameState} from "../services/IFrameState";
import {PANEL_TYPE, POPUP_GATE_TRANSITION_TIME} from "../../blink-sdk/Constants";
import {donateMobileState} from "./inline-donation/DonateMobileState";
import {subscribeFlowState} from "./inline-subscription/SubscribeFlowState";
import {giftSubscriptionFlowState} from "./inline-subscription/GiftSubscriptionFlowState";
import {iFrameConnection} from "../services/IFrameConnection";
import {IFrameMessages} from "../../blink-sdk/messaging/IFrameMessages";


export function initializeFlows() {
    let panelType = null;
    let activeFlow = null;
    let clearTimeoutId = null;

    const clearActiveFlow = () => {
        if (activeFlow) {
            activeFlow.clear();
        }
        panelType = null;
        activeFlow = null;
        clearTimeout(clearTimeoutId);
        clearTimeoutId = null;
    }
    const clearActiveFlowDelayed = () => {
        clearTimeoutId = setTimeout(clearActiveFlow, POPUP_GATE_TRANSITION_TIME)
    }
    const updateActiveFlow = iframeParams => {
        if (!iframeParams.type || panelType === iframeParams.type) {
            return;
        }
        panelType = iframeParams.type;
        // This needs to be done here too because first route change isn't dispatched.
        if (panelType === PANEL_TYPE.empty) {
            clearActiveFlowDelayed();
            return;
        }
        if (clearTimeoutId) {
            clearActiveFlow();
        }
        if (panelType === PANEL_TYPE.donation) {
            activeFlow = donateMobileState;
        } else if (panelType === PANEL_TYPE.subscribe) {
            activeFlow = subscribeFlowState;
        } else if (panelType === PANEL_TYPE.giftSubscription) {
            activeFlow = giftSubscriptionFlowState;
        }

        if (activeFlow) {
            activeFlow.init();
        }
    }
    iFrameState.addUpdateListener(updateActiveFlow);
    updateActiveFlow(iFrameState.iframeParams);

    iFrameConnection.addListener(IFrameMessages.ROUTE_CHANGE, ({url}) => {
        if (url === PANEL_TYPE.empty) {
            clearActiveFlowDelayed();
        }
    });
}
